import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import getLang from 'LearningCenterUI/utils/getLang';
// @ts-expect-error untyped dependency
import FormattedDuration from 'I18n/components/FormattedDuration';

//@ts-expect-error Could not find declaration file for module
import chapterThumbnailUrl from 'bender-url!../../../images/pngs/chapter_thumbnail.png';
//@ts-expect-error Could not find declaration file for module
import practicalExerciseThumbnailUrl from 'bender-url!../../../images/pngs/practical_exercise_thumbnail.png';
//@ts-expect-error Could not find declaration file for module
import quizThumbnailUrl from 'bender-url!../../../images/pngs/quiz_thumbnail.png';
import ReducedCardLayout from '../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardLayout';
import UsageTracker from '../../utils/UsageTracker';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { CardMenuIcon } from '../../features/cardMenu';
import { useFullLesson } from '../../features/lessons/lessonQueries';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
//@ts-expect-error Could not find declaration file for module
import { getLesson } from '../../selectors/lessonSelectors';
import { videoReferenceType } from '../../constants/ContentConstants';
import { getFullUrl } from 'hubspot-url-utils';
import { useAvailableLanguages } from '../../features/contentLanguage';
import InstructorList from '../../components/InstructorList';
import { OverviewContent, OverviewModalCurriculumSection, OverviewModalDescriptionSection, useOverviewNavigation } from '../../features/overview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FallbackThumbnailUrls = {
  CHAPTER: chapterThumbnailUrl,
  PRACTICAL_EXERCISE_FLOW: practicalExerciseThumbnailUrl,
  QUIZ: quizThumbnailUrl
};
const LessonOverviewModalContainer = ({
  lessonId: lessonIdFromProps,
  language: languageFromProps,
  allowFullWidthChildren
}) => {
  const {
    source,
    lessonId: lessonIdFromParams,
    language: paramLanguage
  } = useParams();
  const lessonId = lessonIdFromProps && lessonIdFromProps.toString() || lessonIdFromParams;
  const [[searchParamLanguage]] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const {
    goTo
  } = useOverviewNavigation();
  const {
    availableLanguagesLoading,
    availableLanguagesData
  } = useAvailableLanguages('lesson', lessonId);
  const language = useMemo(() => {
    const chosenLanguage = (languageFromProps || paramLanguage || searchParamLanguage || getLang()).toUpperCase();
    if (availableLanguagesData && availableLanguagesData.length && !availableLanguagesData.includes(chosenLanguage)) {
      // default to English if available
      return availableLanguagesData.includes('EN') ? 'EN' : availableLanguagesData[0];
    }
    return chosenLanguage;
  }, [availableLanguagesData, languageFromProps, paramLanguage, searchParamLanguage]);
  const {
    lessonLoading: loading,
    lesson,
    lessonError: error
  } = useFullLesson(Number(lessonId), language, availableLanguagesLoading);
  const lessonContent = useSelector(state => getLesson(state, {
    lessonId
  }));
  const deprecated = lessonContent && lessonContent.get('deprecated');
  const deprecationCta = lessonContent && lessonContent.get('deprecationCta');
  const hubspotDomain = getFullUrl('app');
  const professors = useMemo(() => {
    if (!lesson) return [];
    const professorsById = {};
    lesson.content.forEach(asset => {
      if (asset.professors) {
        asset.professors.forEach(professor => {
          professorsById[professor.id] = professor;
        });
      }
    });
    return Object.values(professorsById);
  }, [lesson]);
  const curriculumContent = useMemo(() => {
    if (!lesson) return [];
    return lesson.content.filter(content => content.contentType !== 'LINK');
  }, [lesson]);
  const handleChangeSelectedLanguage = ({
    target: {
      value
    }
  }) => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-change-language',
      appearsIn: source,
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null,
      previousLanguage: language,
      newLanguage: value
    });
    goTo({
      id: parseInt(lessonId, 10),
      type: 'LESSON',
      language: value
    });
  };
  const handleEnroll = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-enroll',
      appearsIn: source,
      contentLanguage: language,
      contentType: 'LESSON',
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null
    });
  };
  const handleContentClick = (content, index) => () => {
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'ASSET',
      assetId: content.id,
      appearsIn: 'lesson-overview-curriculum',
      position: index + 1,
      name: content.name,
      style: 'reduced',
      language
    });
  };
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'LESSON',
      appearsIn: 'lesson-overview-curriculum',
      organisation,
      organisationUrl,
      professorId,
      lessonId
    });
  };
  const getContentThumbnail = content => {
    if (content.content_type === 'VIDEO') {
      if (content.referenceType === videoReferenceType.HUBSPOT_VIDEO) {
        return `${hubspotDomain}/api/video/v1/public/${content.reference}/poster?portalId=${content.hubId}`;
      } else {
        const videoReference = content.vidyardUuid || content.reference;
        return `https://play.vidyard.com/${videoReference}.jpg`;
      }
    } else {
      return content.previewThumbnailSquareUrl || FallbackThumbnailUrls[content.contentType];
    }
  };
  const getCurriculumDuration = content => new Date().getTime() - (content.duration || 0) * 1000;
  return /*#__PURE__*/_jsxs(OverviewContent, {
    allowFullWidthChildren: allowFullWidthChildren,
    assetLanguage: language,
    deprecated: deprecated,
    deprecationCta: deprecationCta,
    error: error,
    fallbackThumbnailUrl: lesson && lesson.previewThumbnailRectangleUrl,
    headerIcons: /*#__PURE__*/_jsx(CardMenuIcon, {
      language: language,
      lessonId: parseInt(lessonId, 10),
      use: "on-dark"
    }),
    lessonId: lessonId,
    loading: loading || availableLanguagesLoading,
    children: [/*#__PURE__*/_jsx(OverviewModalDescriptionSection, {
      availableLanguages: availableLanguagesData,
      availableLanguagesLoading: availableLanguagesLoading,
      contentList: lesson && lesson.content,
      description: lesson && lesson.description,
      duration: lesson && /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date().getTime() - lesson.duration * 1000
      }),
      hasStudyGuide: lesson && !!lesson.studyGuide,
      id: lesson && lesson.id,
      onChangeSelectedLanguage: handleChangeSelectedLanguage,
      onEnroll: handleEnroll,
      selectedLanguage: language,
      title: lesson && lesson.name,
      type: "LESSON"
    }), !!professors.length && /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      language: language,
      professors: professors
    }), !!curriculumContent.length && /*#__PURE__*/_jsx(OverviewModalCurriculumSection, {
      children: curriculumContent.map((content, index) => /*#__PURE__*/_jsx(ReducedCardLayout, {
        contentId: content.id,
        name: content.name,
        onClick: handleContentClick(content, index),
        thumbnailUrl: getContentThumbnail(content),
        to: `/lessons/${lessonId}/${content.id}?language=${language}`,
        use: "on-dark",
        verticalGap: 28,
        children: /*#__PURE__*/_jsx(FormattedDuration, {
          from: getCurriculumDuration(content)
        })
      }, content.id))
    })]
  });
};
export default LessonOverviewModalContainer;